<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title text="Filtros"></app-sub-title>
            </b-col>
        </b-row>
        <b-row class="mb-2" align-v="end">
            <b-col cols="12" md="4" v-if="!user.profile.client_side">
                <app-autocomplete
                    v-model="filters.clientId"
                    :items="clients"
                    label="Cliente"
                    @change="loadRounds"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="3">
                <app-autocomplete
                    :items="rounds"
                    v-model="filters.roundId"
                    label="Ronda"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="3">
                <app-autocomplete
                    v-model="filters.userId"
                    :items="guards"
                    label="Vigilante"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <div class="w-100"></div>
            <b-col cols="12" md="2">
                <app-form-date
                    v-model="filters.dateIni"
                    label="Desde"
                ></app-form-date>
            </b-col>
            <b-col cols="12" md="2">
                <app-form-date
                    v-model="filters.dateEnd"
                    label="Hasta"
                ></app-form-date>
            </b-col>
            <b-col cols="12" md="2" align-v="end">
                <b-btn size="sm" variant="primary" @click="onFilter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn size="sm" variant="success" @click="onExport"
                    ><i class="fa fa-file-excel-o"></i
                ></b-btn>
                <b-btn size="sm" variant="secondary" @click="onReset"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import roundsRepository from '@repositories/rounds.repository'
import usersRepository from '@repositories/users.repository'
export default {
    data: () => ({
        filters: {
            clientId: '',
            roundId: '',
            userId: '',
            dateIni: '',
            dateEnd: '',
        },
        rounds: [],
        guards: [],
    }),
    computed: {
        ...mapGetters(['clients']),
        theFilters() {
            const isClientSide = this.user?.profile?.client_side
            return isClientSide ? { ...this.filters, clientId: this.client.id } : this.filters
        },
    },
    methods: {
        async loadRounds() {
            const rr = { ...roundsRepository }
            try {
                const { data } = await rr.get({
                    clientId: this.theFilters.clientId,
                })

                this.rounds = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        async loadGuards() {
            const ur = { ...usersRepository }
            try {
                const { data } = await ur.getGuards()
                this.guards = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onFilter() {
            this.$emit('filter', this.theFilters)
        },
        onReset() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.onFilter()
        },
        onExport() {
            const params = []
            const exportFilters = this.theFilters
            Object.keys(exportFilters).forEach(key => {
                if (exportFilters[key]) params.push(`${key}=${exportFilters[key]}`)
            })
            window.open(`exports/rounds/export-excel?${params.join('&')}`, '_blank')
        },
    },
    mounted() {
        this.load('clients')
        this.loadGuards()
        if (this.user.profile.client_side) {
            this.loadRounds()
        }
    },
}
</script>
